import * as React from 'react';
import { DirectionsTransit, LaunchOutlined, RoomOutlined } from '@material-ui/icons';
import './homeLocationSummary.module.scss';
import { UserHomeLocationIndexView } from '../../../types/home_locations';

const LocationSummary = ({ location }) => {
  if (!location) {
    return (
      <div styleName="location-summary">
        <div styleName="title">オンライン</div>
        <div styleName="description">関東圏以外からのご利用など、基本的にオンライン利用のみのご利用です</div>
      </div>
    );
  }
  const GoogleMapLink = ({ className = undefined }) => (
    <a styleName="link" className={className} href={location.google_map_url} target="_blank">
      Google Mapで見る
      <LaunchOutlined styleName="link-icon" />
    </a>
  );
  return (
    <div styleName="location-summary">
      <div styleName="title">{location.name}</div>
      <div styleName="address">
        <RoomOutlined styleName="icon" />
        <span>
          〒{location.zipcode} {location.address}
        </span>
      </div>
      {location.access_summary && (
        <div styleName="access-summary">
          <DirectionsTransit styleName="icon" />
          {location.access_summary}
        </div>
      )}
      <GoogleMapLink styleName={'bottom'} />
    </div>
  );
};

type Props = {
  userHomeLocation: UserHomeLocationIndexView | null;
};

export const HomeLocationSummary = ({ userHomeLocation }: Props) => {
  return (
    <div styleName="home-location-summary">
      <div styleName="header">あなたのホーム拠点</div>
      {userHomeLocation ? (
        <LocationSummary location={userHomeLocation.location} />
      ) : (
        <div styleName="empty-text">ホーム拠点が設定されていません</div>
      )}
    </div>
  );
};
